import { render, staticRenderFns } from "./ResultTo5.vue?vue&type=template&id=4ea64c10&scoped=true&"
import script from "./ResultTo5.vue?vue&type=script&lang=js&"
export * from "./ResultTo5.vue?vue&type=script&lang=js&"
import style0 from "./ResultTo5.vue?vue&type=style&index=0&id=4ea64c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea64c10",
  null
  
)

export default component.exports